module.exports = __webpack_public_path__ + "static/media/warning-icon.79b5d5c8.svg";